<template>
  <div id="index" ref="appRef">
    <dv-loading v-if="loading">Loading...</dv-loading>
    <div v-else class="host-body">
      <div class="header">
        <h2>湖北省散预信息化平台</h2>
      </div>
      <div class="Container">
        <div class="left" @click="toPath('Credit')">
          <div class="leftTop">
            <dv-border-box-12>
              <div style="padding: 10px 20px">
                <dv-decoration-7 style="width: 470px; height: 30px"> <span style="margin: 0 10px">前十名</span> </dv-decoration-7>
                <!-- <dv-scroll-board :config="configleft1" style="width: 470px; height: 410px; text-align: center" /> -->
                <div class="items">
                  <div class="item">
                    <div>排名</div>
                    <div>企业名称</div>
                    <div>信用得分</div>
                    <div>所属辖区</div>
                  </div>
                  <div class="item" v-for="(item, index) in Arrleft1" :key="item.id">
                    <div>{{ index + 1 }}</div>
                    <div>{{ item.entname }}</div>
                    <div>{{ item.entscore }}</div>
                    <div>{{ item.cityname }}</div>
                  </div>
                </div>
              </div>
            </dv-border-box-12>
          </div>
          <div class="leftBottom">
            <div>
              <dv-border-box-12>
                <div style="padding: 10px 20px">
                  <dv-decoration-7 style="width: 470px; height: 30px"> <span style="margin: 0 10px">整体排名情况</span> </dv-decoration-7>
                  <dv-scroll-board v-if="configleft2.data.length" :config="configleft2" style="width: 470px; height: 180px; text-align: center" />
                </div>
              </dv-border-box-12>
            </div>
            <div>
              <dv-border-box-12>
                <div style="padding: 10px 20px">
                  <dv-decoration-7 style="width: 470px; height: 30px"> <span style="margin: 0 10px">低于100分</span> </dv-decoration-7>
                  <dv-scroll-board v-if="configleft3.data.length" :config="configleft3" style="width: 470px; height: 180px; text-align: center" />
                </div>
              </dv-border-box-12>
            </div>
          </div>
        </div>
        <div class="middle">
          <!-- <div class="header">
            <div class="item">
              <div class="title">接入</div>
              <div class="txt Home">{{ obj.data1 }}</div>
            </div>
            <div class="item">
              <div class="title">本月</div>
              <div class="txt Wan-Fang">{{ obj.data2 }}</div>
            </div>
            <div class="item">
              <div class="title">本年</div>
              <div class="txt Wan-Fang">{{ obj.data3 }}</div>
            </div>
          </div> -->
          <div style="display: flex; justify-content: center; align-items: center">
            <centerLeft2 />
          </div>
          <div>
            <dv-border-box-12>
              <centerBottom2 />
            </dv-border-box-12>
          </div>
        </div>
        <div class="right">
          <div class="Drop-down">
            注册/登陆
            <div class="ul">
              <div class="li">
                <a :href="SSOHBGov" target="_blank">散预信息化主管部门登陆</a>
              </div>
              <div class="li"><a :href="SSOHBUnite" target="_blank">散预信息化企业登陆</a></div>
            </div>
          </div>
          <div @click="toPath('GreenProduction')">
            <dv-border-box-12>
              <div style="padding: 10px 20px">
                <dv-decoration-7 style="width: 470px; height: 30px"> <span style="margin: 0 10px">绿色生产评价</span> </dv-decoration-7>
                <dv-scroll-board v-if="configright1.data.length" :config="configright1" style="width: 470px; height: 400px; text-align: center" />
              </div>
            </dv-border-box-12>
          </div>
          <div @click="toPath('GreenBuildingMaterials')">
            <dv-border-box-12>
              <div style="padding: 10px 20px">
                <dv-decoration-7 style="width: 470px; height: 30px"> <span style="margin: 0 10px">绿色建材认证</span> </dv-decoration-7>
                <dv-scroll-board v-if="configright2.data.length" :config="configright2" style="width: 470px; height: 400px; text-align: center" />
              </div>
            </dv-border-box-12>
          </div>
          <!-- <div>
            <dv-border-box-12>
              <centerRight3 />
            </dv-border-box-12>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import drawMixin from '../utils/drawMixin'
import { formatTime } from '../utils/index.js'
import centerLeft2 from './centerLeft2'
import centerBottom2 from './centerBottom2'
// import centerRight3 from './centerRight3'
import * as API from '../common/common.js'

export default {
  mixins: [drawMixin],
  data() {
    return {
      timing: null,
      loading: true,
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      weekday: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      decorationColor: ['#568aea', '#000000'],
      obj: {
        data1: 0,
        data2: 0,
        data3: 0
      },
      SSOHBUnite: '',
      SSOHBGov: '',
      Arrleft1: [],
      Arrleft2: [],
      // configleft1: {
      //   header: ['排名', '企业名称', '信用积分', '所属辖区'],
      //   data: [],
      //   headerBGC: 'transparent',
      //   oddRowBGC: 'transparent',
      //   evenRowBGC: 'transparent',
      //   columnWidth: [100, 500, 200, 200],
      //   align: 'center'
      // },
      configleft2: {
        header: ['排名', '企业名称', '信用得分', '所属辖区'],
        data: [],
        headerBGC: 'transparent',
        oddRowBGC: 'transparent',
        evenRowBGC: 'transparent',
        columnWidth: [100, 500, 200, 200],
        align: 'center',
        rowNum: 4
        // carousel: 'page'
      },
      configleft3: {
        header: ['排名', '企业名称', '信用得分', '所属辖区'],
        data: [],
        headerBGC: 'transparent',
        oddRowBGC: 'transparent',
        evenRowBGC: 'transparent',
        columnWidth: [100, 500, 200, 200],
        align: 'center',
        rowNum: 4
        // carousel: 'page'
      },
      configright1: {
        header: ['企业名称', '类别', '等级', '有效期', '所属辖区'],
        data: [],
        headerBGC: 'transparent',
        oddRowBGC: 'transparent',
        evenRowBGC: 'transparent',
        align: 'center',
        columnWidth: [280, 100, 65, 70, 95],
        rowNum: 10
        // carousel: 'page'
      },
      configright2: {
        header: ['企业名称', '类别', '等级', '有效期', '所属辖区'],
        data: [],
        headerBGC: 'transparent',
        oddRowBGC: 'transparent',
        evenRowBGC: 'transparent',
        align: 'center',
        columnWidth: [280, 100, 65, 70, 95],
        rowNum: 10
        // carousel: 'page'
      }
    }
  },
  components: {
    centerLeft2,
    centerBottom2
    // centerRight3
  },
  created() {
    this.init()
  },
  mounted() {
    this.timeFn()
    this.cancelLoading()
  },
  beforeDestroy() {
    clearInterval(this.timing)
  },
  methods: {
    init() {
      API.getSsoUrl('SSOHBUnite').then((res) => (this.SSOHBUnite = res))
      API.getSsoUrl('SSOHBGov').then((res) => (this.SSOHBGov = res))
      API.GetDataByProvinceWide().then(({ data }) => (this.obj = data.data))
      // API.GetCreditScore_TopTen().then(({ data }) => {
      //   const arr = data.data.map((e) => {
      //     return [e.creditScoreRank, e.companyName, e.creditScore, e.cityName]
      //   })
      //   this.$set(this.configleft1, 'data', arr)
      // })
      API.GetCreditScore_TopTen().then(({ data }) => (this.Arrleft1 = data.data))
      // API.GetCreditScore_LastTen().then(({ data }) => {
      //   const arr = data.data.map((e) => {
      //     return [e.creditScoreRank, e.companyName, e.creditScore, e.cityName]
      //   })
      //   this.$set(this.configleft2, 'data', arr)
      // })
      API.GetCreditScore_LastTen().then(({ data }) => {
        const arr = data.data.map((e, i) => {
          return [i + 1, e.entname, e.entscore, e.cityname]
        })
        this.$set(this.configleft2, 'data', arr)
        this.$set(
          this.configleft3,
          'data',
          arr.filter((e) => e[2] < 100)
        )
      })
      API.GetDataByGreenProduce().then(({ data }) => {
        const arr = data.data.map((e) => {
          return [e.companyName, e.companyType, e.greenProduceGrade, e.effectiveTime, e.cityName]
        })
        this.$set(this.configright1, 'data', arr)
      })
      API.GetDataByGreenMaterial().then(({ data }) => {
        const arr = data.data.map((e) => {
          return [e.companyName, e.companyType, e.greenMaterialGrade, e.effectiveTime, e.cityName]
        })
        this.$set(this.configright2, 'data', arr)
      })
    },
    timeFn() {
      this.timing = setInterval(() => {
        this.dateDay = formatTime(new Date(), 'HH: mm: ss')
        this.dateYear = formatTime(new Date(), 'yyyy-MM-dd')
        this.dateWeek = this.weekday[new Date().getDay()]
      }, 1000)
    },
    cancelLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    toPath(path) {
      window.open(window.location.href + path, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.right .dv-scroll-board .rows .ceil) {
  padding: 0 2px;
}
:deep(.right .dv-scroll-board .header .header-item) {
  padding: 0 2px;
}
@import '../assets/scss/index.scss';
</style>
